export default {
    getImageSearch: function (state) {
        return state.imageSearchList
    },

    getImageServerSelect: function (state) {
        return state.imageServerSelect
    },

    getQuiz: function (state) {
        return state.question
    },

    getQuizStatus: function (state) {
        return state.question.status
    },

    getQuizId: function (state) {
        return state.question._id
    },

    getQuestions: function (state) {

        return state.question.questions
    },

    getCurrentQuiz: function (state) {

        return state.question.questions[state.playingCurrentQuestionIndex]
    },

    currentQuizIndex: function (state) {
        return state.playingCurrentQuestionIndex
    },

    isEndQuiz: function (state) {

        return state.playingCurrentQuestionIndex == state.question.questions.length - 1
    },

    getQuestionCount: function (state) {

        return state.question.questions.length
    },

    getDifiniteAudio: function (state) {

        return state.audioDefinite
    },

    getPluckyAudio: function (state) {

        return state.audioPlucky
    },

    getWrongAudio: function (state) {

        return state.audioWrong
    },

    getSilenceAudio: function (state) {

        return state.audioSilence
    },

    getIntervalNoSleep: function (state) {

        return state.intervalNoSleep
    },

    getFrontPageSetting: function (state) {
        return state.frontPageSetting
    },

    getFrontPageBackgroundSet: function (state) {
        return state.frontPageBackgroundSet
    },

    orderAbility: function (state) {
        return state.orderAbility
    },

    getSpotifyAudio: function (state) {

        return state.audioSpotify
    },

    getBgAudio: function (state) {
        return state.audioBg
    },

    getIsPlaySongUser: function (state) {

        return state.isPlaySongUser
    },

    getIsPlaySongMaster: function (state) {

        return state.isPlaySongMaster
    },

    getDelayAnswer: function (state) {

        return state.delayAnswer
    },

    getDelayQuestion: function (state) {

        return state.delayQuestion
    },

    getTimeLimit: function (state) {

        return state.timeLimit
    },

    getMasterSound: function (state) {

        return state.masterSound
    },

    getPlayerSound: function (state) {

        return state.playerSound
    },

    getProgressBarStatus: function (state) {

        return state.progressBarStatus
    },

    getMasterResultSetting: function (state) {

        return state.masterResult
    },

    getMasterQuestion: function (state) {

        return state.masterQuestion
    },

    getMasterEffect: function (state) {

        return state.masterEffect
    },

    getPlayerQuestion: function (state) {

        return state.playerQuestion
    },

    getPlayerEffect: function (state) {

        return state.playerEffect
    },

    getUserCredit: function (state) {

        return state.credit
    },

    getRelateQuiz: function (state) {
        return state.relateQuiz
    },

    isQuizNotFinishLogCreated: function (state) {

        return state.isQuizNotFinishLogCreated
    },

    isActiveOnly: function (state) {
        return state.isActiveOnly
    },

    parentQuizCode: function (state) {
        return state.parentQuizCode
    },

    isReconnectPopup: function (state) {
        return state.isReconnectPopup
    },

    playerCount: function (state) {
        return state.playerCount
    },

    userPlayingInfo: function (state) {
        return state.userPlayingInfo
    },

    getCouponCode: function (state) {
        return state.couponCode
    },

    getIsCreateNewQuiz: function (state) {
        return state.isCreateNewQuiz
    },

    themes: function (state) {
        return state.question.themes
    },

    themeName: function (state) {
        return state.question.theme_name
    },

    diffQuestionLength: function (state) {
        return state.diffQuestionLength
    },

    paymentModalTitle: function (state) {
        return state.paymentModalTitle
    },

    paymentModalDescription: function (state) {
        return state.paymentModalDescription
    },

    isShowPaymentPopup: function (state) {
        return state.isShowPaymentPopup
    },

    isShowWhitelistModal: function (state) {
        return state.isShowWhitelistModal
    },

    whitelitModalData: function (state) {
        return state.whitelitModalData
    },

    typeUpgradeModal: function (state) {
        return state.typeUpgradeModal
    },

    getSystemSetting: function (state) {
        return state.systemSetting
    },

    isShowMergeReportModal: function (state) {
        return state.isShowMergeReportModal
    },

    getQuizByUser: function (state) {
        return state.quizByUser
    },

    getOriginalUserReports: function (state) {
        return state.originalUserReports
    },

    getOriginalSharedReports: function (state) {
        return state.originalSharedReports
    },
}
